module.exports = __webpack_public_path__ + "images/help/video-files@2x-62d85e96781f4dc4378d7aeea331669a.png";